<nav class="flex items-center justify-between border-t border-gray-200 mb-4 px-4 sm:px-0">
    <div class="-mt-px flex w-0 flex-1">
        <a
            rel="prev"
            class="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium"
            [routerLink]="[]"
            queryParamsHandling="merge"
            [queryParams]="{ pageIndex: pageIndex - 1 }"
            [ngClass]="{
                'text-gray-300 hover:border-gray-300 hover:text-gray-100': entity?.darkMode,
                'text-gray-500 hover:border-gray-300 hover:text-gray-700': !entity?.darkMode,
                'text-gray-500 cursor-auto pointer-events-none': !entity?.darkMode && pageIndex === 0,
                'text-gray-300 cursor-auto pointer-events-none': entity?.darkMode && pageIndex === 0
            }">
            <svg class="mr-3 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                    fill-rule="evenodd"
                    d="M18 10a.75.75 0 01-.75.75H4.66l2.1 1.95a.75.75 0 11-1.02 1.1l-3.5-3.25a.75.75 0 010-1.1l3.5-3.25a.75.75 0 111.02 1.1l-2.1 1.95h12.59A.75.75 0 0118 10z"
                    clip-rule="evenodd" />
            </svg>
            Previous
        </a>
    </div>
    <div class="hidden md:-mt-px md:flex" *ngIf="pages?.length < 10">
        <a
            *ngFor="let page of pages"
            [routerLink]="[]"
            queryParamsHandling="merge"
            [queryParams]="{ pageIndex: page }"
            class="inline-flex items-center border-t-2 border-transparent px-2 pt-4 text-sm font-medium"
            [ngClass]="{
                'text-gray-300 hover:border-gray-300 hover:text-gray-100': entity?.darkMode,
                'text-gray-500 hover:border-gray-300 hover:text-gray-700': !entity?.darkMode,
                'border-white text-white': entity?.darkMode && pageIndex === page,
                'border-indigo-500 text-indigo-600': !entity?.darkMode && pageIndex === page,
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': pageIndex !== page
            }">
            {{ page + 1 }}
        </a>
    </div>
    <div class="hidden md:-mt-px md:flex" *ngIf="pages?.length > 10">
        <a
            [routerLink]="[]"
            queryParamsHandling="merge"
            [queryParams]="{ pageIndex: 0 }"
            class="inline-flex items-center border-t-2 border-transparent px-2 pt-4 text-sm font-medium"
            [ngClass]="{
                'text-gray-300 hover:border-gray-300 hover:text-gray-100': entity?.darkMode,
                'text-gray-500 hover:border-gray-300 hover:text-gray-700': !entity?.darkMode,
                'border-white text-white': entity?.darkMode && pageIndex === 0,
                'border-indigo-500 text-indigo-600': !entity?.darkMode && pageIndex === 0,
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': pageIndex !== 0
            }">
            1
        </a>
        <a
            [routerLink]="[]"
            queryParamsHandling="merge"
            [queryParams]="{ pageIndex: 1 }"
            class="inline-flex items-center border-t-2 border-transparent px-2 pt-4 text-sm font-medium"
            [ngClass]="{
                'text-gray-300 hover:border-gray-300 hover:text-gray-100': entity?.darkMode,
                'text-gray-500 hover:border-gray-300 hover:text-gray-700': !entity?.darkMode,
                'border-white text-white': entity?.darkMode && pageIndex === 1,
                'border-indigo-500 text-indigo-600': !entity?.darkMode && pageIndex === 1,
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': pageIndex !== 1
            }">
            2
        </a>
        <a
            [routerLink]="[]"
            queryParamsHandling="merge"
            [queryParams]="{ pageIndex: 2 }"
            class="inline-flex items-center border-t-2 border-transparent px-2 pt-4 text-sm font-medium"
            [ngClass]="{
                'text-gray-300 hover:border-gray-300 hover:text-gray-100': entity?.darkMode,
                'text-gray-500 hover:border-gray-300 hover:text-gray-700': !entity?.darkMode,
                'border-white text-white': entity?.darkMode && pageIndex === 2,
                'border-indigo-500 text-indigo-600': !entity?.darkMode && pageIndex === 2,
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': pageIndex !== 2
            }">
            3
        </a>
        <span class="inline-flex items-center border-t-2 border-transparent px-2 pt-4 text-sm font-medium">...</span>
        <a
            [routerLink]="[]"
            queryParamsHandling="merge"
            [queryParams]="{ pageIndex: pages.length - 3 }"
            class="inline-flex items-center border-t-2 border-transparent px-2 pt-4 text-sm font-medium"
            [ngClass]="{
                'text-gray-300 hover:border-gray-300 hover:text-gray-100': entity?.darkMode,
                'text-gray-500 hover:border-gray-300 hover:text-gray-700': !entity?.darkMode,
                'border-white text-white': entity?.darkMode && pageIndex === pages.length - 3,
                'border-indigo-500 text-indigo-600': !entity?.darkMode && pageIndex === pages.length - 3,
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300':
                    pageIndex !== pages.length - 3
            }">
            {{ pages.length - 3 }}
        </a>
        <a
            [routerLink]="[]"
            queryParamsHandling="merge"
            [queryParams]="{ pageIndex: pages.length - 2 }"
            class="inline-flex items-center border-t-2 border-transparent px-2 pt-4 text-sm font-medium"
            [ngClass]="{
                'text-gray-300 hover:border-gray-300 hover:text-gray-100': entity?.darkMode,
                'text-gray-500 hover:border-gray-300 hover:text-gray-700': !entity?.darkMode,
                'border-white text-white': entity?.darkMode && pageIndex === pages.length - 2,
                'border-indigo-500 text-indigo-600': !entity?.darkMode && pageIndex === pages.length - 2,
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300':
                    pageIndex !== pages.length - 2
            }">
            {{ pages.length - 2 }}
        </a>
        <a
            [routerLink]="[]"
            queryParamsHandling="merge"
            [queryParams]="{ pageIndex: pages.length - 1 }"
            class="inline-flex items-center border-t-2 border-transparent px-2 pt-4 text-sm font-medium"
            [ngClass]="{
                'text-gray-300 hover:border-gray-300 hover:text-gray-100': entity?.darkMode,
                'text-gray-500 hover:border-gray-300 hover:text-gray-700': !entity?.darkMode,
                'border-white text-white': entity?.darkMode && pageIndex === pages.length - 1,
                'border-indigo-500 text-indigo-600': !entity?.darkMode && pageIndex === pages.length - 1,
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300':
                    pageIndex !== pages.length - 1
            }">
            {{ pages.length - 1 }}
        </a>
    </div>
    <div class="-mt-px flex w-0 flex-1 justify-end">
        <a
            rel="next"
            class="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium"
            [routerLink]="[]"
            [queryParams]="{ pageIndex: pageIndex + 1 }"
            queryParamsHandling="merge"
            [ngClass]="{
                'text-gray-300 hover:border-gray-300 hover:text-gray-100': entity?.darkMode,
                'text-gray-500 hover:border-gray-300 hover:text-gray-700': !entity?.darkMode,
                'text-gray-500 cursor-auto pointer-events-none':  pageIndex >= pages.length - 1,
            }">
            Next
            <svg class="ml-3 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                    fill-rule="evenodd"
                    d="M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z"
                    clip-rule="evenodd" />
            </svg>
        </a>
    </div>
</nav>
